import React from "react"
import { DemoCallsConsole } from "@/features/demo-calls"

export default function DemoCallsPage() {
  return <DemoCallsConsole />
}
